export default {
  title: '您现在可以关闭此页面。如果您有任何问题，请随时致电联系我们，电话是',
  'call-rating': '通话评分',
  comment: {
    title: '请留下您的评论：',
    placeholder: '写下您是否满意，您的期望和感受',
    error: '如果您给了较差的评分，请说明哪里有问题？',
    'send-btn': '发送',
  },
  'accepted-message': '您的反馈已被接受。感谢您使用我们的配送服务！',
}
